"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function OurStory() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const imageRef = useRef<HTMLDivElement>(null);
  const [scrollScale, setScrollScale] = useState(1);
  useEffect(() => {
    const handleScroll = () => {
      if (!imageRef.current) return;
      const rect = imageRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const elementTop = rect.top;
      const elementHeight = rect.height;
      if (elementTop < windowHeight && elementTop + elementHeight > 0) {
        const scrollProgress = Math.max(0, Math.min(1, (windowHeight - elementTop) / (windowHeight + elementHeight)));
        const newScale = 1 + scrollProgress * 0.05;
        setScrollScale(newScale);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="our-story" className="dark bg-background text-foreground relative min-h-screen w-full overflow-hidden">
      <div ref={imageRef} className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] bg-[url(/img/luxury_chauffeur_story_background.png)]" style={{
      transform: `scale(${scrollScale})`
    }}>
        <div className="surface-overlay" />
      </div>

      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 py-16 md:py-24 lg:py-32">
        <div ref={textRef} className={`glass-effect max-w-3xl p-8 md:p-12 lg:p-16 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-white">
            Our Story
          </h2>
          <div className="space-y-4 text-base md:text-lg leading-relaxed text-white/90">
            <p>Phoenix Enterprises Limousine Service was born from a vision to redefine luxury transportation in Los Angeles. What started as a commitment to punctuality and privacy has evolved into a premier chauffeur service trusted by business executives, travelers, and discerning clients across Southern California.</p>
            <p>Our fleet of high-end sedans and SUVs represents more than just transportationit's an experience crafted around your needs. From airport transfers to VIP events, we've built our reputation on reliability, discretion, and unwavering attention to detail.</p>
            <img src="https://humane-alien.10web.cloud/wp-content/uploads/2026/02/ChatGPT-Image-Feb-18-2026-11_41_33-AM.png" alt="New cars with clients" className="w-full rounded-md shadow-medium my-6" />
            <p>Every journey with Phoenix Enterprises Limousine Service is a testament to our dedication to excellence. We don't just drive you to your destination; we ensure every moment on the road reflects the premium standard you deserve.</p>
          </div>
        </div>
      </div>
    </section>;
}